import React from 'react';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '@material-ui/core/Card';
import InputBase from '@material-ui/core/InputBase';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import ReactDragList from "react-drag-list";
import ConfirmModal from '../../../../../../components/ConfirmModal/ConfirmModal';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import SaveIcon from '@material-ui/icons/Save';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { Tooltip, Typography, Button, ListItemAvatar, AccordionSummary,Accordion,AccordionDetails } from '@material-ui/core';
import SystemLabel from '../../../../../../system/SystemLabel/SystemLabel';
import { Input, Row, Col } from 'reactstrap';
import PagesIcon from '@material-ui/icons/Pages';
import HelpIcon from '@material-ui/icons/Help';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import LiveTvIcon from '@material-ui/icons/LiveTv';


const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        backgroundColor: '#3a3b3c',
        borderRadius: 5,
        marginRight: theme.spacing(2),
        marginLeft: 10,
        marginRight: 10,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: 0,
            marginLeft: 10,
            marginRight: 10,
            width: '100%',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        color: '#FFFFFF99',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        color: '#FFFFFF99',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    online: {
        background: '#44b700'
    },
    offline: {
        background: 'orangered'
    },
}));



export default function PresetItems(props) {
    const [filter, setFilter] = React.useState('');
    const [presetName, setPresetName] = React.useState('');
    const [open, toggleModal] = React.useState(false);
    const [unlocked, setUnlocked] = React.useState(false);
    const [hasChanged, setChanged] = React.useState(false);
    const [modifiedItems, setItems] = React.useState(props.presetItems)
    const [deleteIndex, setDeleteIndex] = React.useState(null);

    const [unSavedWarning, setUnsaved] = React.useState(false);
    const sortItems = (presetItems) => {
        if (!presetItems || presetItems === "" || (presetItems && presetItems.length === 0)) return [];
        let res = [];
        presetItems.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
        })
        presetItems.map((a, i) => {
            a.sortOrder = i;
        })
        return presetItems;
    }
    function onUnlock(val, force = false) {
        if (force) {
            setUnsaved(false)
        }
        else if (hasChanged && val === false) {
            setUnsaved(true)
            return;
        }
        var presetItems = unlocked ? sortItems(modifiedItems) : sortItems(props.presetItems);
        setItems(presetItems);
        setUnlocked(val);
    }
    const toggleDelete = (val, index) => {
        if (val === true && deleteIndex !== null) {
            setDeleteIndex(null);
        }
        setDeleteIndex(index);
        toggleModal(val)
    }

    const handleOrderChange = (event, dataSource) => {
        const sortedItems = dataSource.map((ds, i) => {
            let el = Object.assign({}, ds);
            el.sortOrder = i;
            return el;
        });
        setItems(sortedItems)
        setChanged(true)
    };

    const defaultPresetItem = (sortOrder, eventId) => {
        return {
            interactionPresetId: sortOrder ? sortOrder * -1 : -1,
            sortOrder,
            name: 'Preset ' + sortOrder,
            active: false,
            content: {
                questions: [],
                modules: [],
                presenter: null,
                agenda: null

            },
            inserted: null,
            updated: null,
            eventId: props.eventId
        }
    };

    const addPreset = () => {
        const presetItems = Array.from(modifiedItems);
        presetItems.push(defaultPresetItem(presetItems ? presetItems.length + 1 : 0, props.eventId))
        setItems(presetItems)
        setChanged(true)
    }
    function deletePreset() {
        if (deleteIndex === null) return;
        if (deleteIndex < 0) {
            let mitems = sortItems(Array.from(modifiedItems));
            mitems = mitems.filter(a => a.interactionPresetId !== deleteIndex);
            mitems.map((m, i) => {
                m.sortOrder = i;
            })
            setItems(mitems)
            setChanged(false)
        } else {
            let mitems = sortItems(Array.from(modifiedItems));
            mitems = mitems.filter(a => a.interactionPresetId !== deleteIndex);
            mitems.map((m, i) => {
                m.sortOrder = i;
            })
            setItems(mitems)
            props.deletePresetItem(deleteIndex);
        }
        setDeleteIndex(null)
        if (open) toggleModal(false)
    }
    const editPreset = (e, index) => {
        let presets = sortItems(Array.from(modifiedItems));
        presets[index].name = e;
        setItems(presets)
        setChanged(true)
    }
    const activatePreset = (preset) => {
        this.props.activatePreset(preset)
    }
    const capturePreset = (id) => {
        this.props.capturePreset(id);
    }
    const save = () => {
        setUnsaved(false);
        const presetItems = Array.from(modifiedItems);
        setChanged(false)
        props.handlePresetOnChange(presetItems);
    }

    const classes = useStyles();
    const { presetItems } = props;
    const presetItemsList = unlocked ? sortItems(modifiedItems) : sortItems(presetItems)
    return (
        <div style={{ marginTop: 10, overflowX: 'hidden' }}>
            <div style={{ width: '100%', display: 'inline-flex' }}>
                <IconButton onClick={() => onUnlock(!unlocked)}
                    edge="start" style={{ padding: '0px 10px', color: '#ffffff99' }}>
                    {unlocked ? <LockOpenIcon /> : <LockIcon />}
                </IconButton>
                {unlocked ? <IconButton
                    onClick={save}
                    disabled={!hasChanged}
                    edge="start" style={{ padding: '0px 10px', color: !hasChanged ? 'rgba(255, 255, 255, 0.28)' : '#ffffff99' }}>
                    <SaveIcon />
                </IconButton> : null}
            </div>
            <List className="dark-list" dense={true} style={{ maxHeight: 'calc(96vh - 191px)', minHeight: 'calc(96vh - 191px)', overflowY: 'auto', paddingBottom: '50px' }}>
                {!unlocked ?
                    presetItemsList.map((a, index) => {
                        return <Card key={index} onClick={() => props.selectPreset(a.interactionPresetId)} className="dark-card" style={{ padding: '0px 5px', margin: '5px 0px', border: a.active ? "3px solid #20a8d8e0" : '3px solid transparent' }}>
                            <ListItem>
                                <Input style={{ color: '#FFFFFF99', backgroundColor: '#3a3b3c', border: '0px', padding: '5px 10px', width: '100%', display: 'inline-block' }}
                                    readOnly={true} value={a.name} />
                                <IconButton className="icon-button-dark-s"
                                    onClick={() => props.activatePresetItem(a.interactionPresetId)}>
                                    <PlayArrowIcon />
                                </IconButton>
                            </ListItem>
                        </Card>
                    })
                    : null}
                {unlocked ?
                    <DragList
                        activatePreset={() => null}
                        modifiedItems={presetItemsList}
                        selectPreset={props.selectPreset}
                        editPreset={editPreset}
                        toggleDelete={toggleDelete}
                        handleOrderChange={handleOrderChange}
                    />
                    : null}
            </List>
            <ConfirmModal
                onAction={() => deletePreset()}
                onCancel={() => toggleModal(!open)}
                header={'AreYouSure'}
                open={open}
                text={'DoWantToDeletePreset'} />
            <ConfirmModal
                onAction={() => save()}
                onCancel={() => onUnlock(!unlocked, true)}
                header={'UnsavedChanges'}
                open={unSavedWarning}
                text={'DoYouWannaSave'} />
        </div >
    );
}

const renderPresetContent = (content) => {
    const contentInfo = <List>
        {presetCollapse({ icon: <HelpIcon />, label: "ActiveQuestions" }, content.questions, 'questions')}
        {presetCollapse({ icon: <ViewModuleIcon />, label: "ActiveModules" }, content.modules, 'modules')}
        <ListItem>
            <Row style={{ width: '100%', margin: '5px 0px' }}>
                <Col className="col-2 text-left secondary-text ">
                    <EventAvailableIcon />
                </Col>
                <Col className="col-8 text-left secondary-text" style={{ padding: '2px' }}>
                    <SystemLabel name={"Agenda"} />
                </Col>
                <Col className="col-2 text-right primary-text" >
                    {content.agenda ? <React.Fragment><SystemLabel name="Dot" /> {content.agenda.sortOrder + 1}</React.Fragment> : <SystemLabel name="None" />}
                </Col>
            </Row>

        </ListItem>
        <ListItem>
            <Row style={{ width: '100%', margin: '5px 0px' }}>
                <Col className="col-2 text-left secondary-text ">
                    <LiveTvIcon />
                </Col>
                <Col className="col-8 text-left secondary-text " style={{ padding: '2px' }}>
                    <SystemLabel name={"PresenterQuestoin"} />
                </Col>
                <Col className="col-2 text-right primary-text" >
                    {content.presenter ? content.presenter.name : <SystemLabel name="None" />}
                </Col>
            </Row>
        </ListItem>
    </List>
    return contentInfo;
}


function presetCollapse(summery, details, type) {
    return <Accordion className="dark-card" style={{ padding: '0px 13px' }}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon className="primary-text" />}
            disabled={(details.length === 0)}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="dark-card"
            style={{
                display: 'inline-flex',
                padding: '0px',
                width: '100%'
            }}
        >
            <Row style={{ width: '100%' }}>
                <Col className="col-2 text-left secondary-text ">
                    {summery.icon}
                </Col>
                <Col className="col-8 text-left secondary-text">
                    <SystemLabel name={summery.label} />
                </Col>
                <Col className="col-2 text-left primary-text" >
                    {type === 'modules' ? details.filter(d => d.visible === true).length : details.length}
                </Col>
            </Row>

        </AccordionSummary>
        <AccordionDetails style={{ display: 'inline-block', width: '100%', padding: '10px 0px' }}>
            {details.map((d, i) => {
                return type === 'modules' ? (
                    <Row key={i}>
                        <Col className="col-2 text-left secondary-text">

                        </Col>
                        <Col className="col-8 text-left" style={{ padding: '0px' }}>
                            <Typography className="primary-text" style={{ marginLeft: '10px' }}>{d.label || d.name}</Typography>
                        </Col>
                        <Col className="col-2 text-right">
                            <Typography className="primary-text" style={{ marginLeft: '10px' }}>{d.visible ? <SystemLabel name="Visible" /> : null}</Typography>
                        </Col>
                    </Row>
                ) :
                    (
                        <Row key={i} tyle={{ width: '100%' }}>
                            <Col className="col-2 text-left secondary-text">
                                <ListItemAvatar className="">
                                    {i + 1}
                                </ListItemAvatar>
                            </Col>
                            <Col className="col-8 text-left" style={{ padding: '0px' }}>
                                <Typography className="primary-text" style={{ marginLeft: '10px' }}>{d.label || d.name}</Typography>
                            </Col>
                            <Col className="col-2 text-right">

                            </Col>
                        </Row>
                    )
            })}

        </AccordionDetails>
    </Accordion>
}

function DragList({ activatePreset, modifiedItems, handleOrderChange, editPreset, toggleDelete, selectPreset }) {
    const onEdit = (e, index) => {
        editPreset(e, index)
    }
    return <div>
        <ReactDragList
            animation={10}
            dataSource={modifiedItems}
            rowKey={"interactionPresetId"}
            className="simple-drag"
            rowClassName="simple-drag-row"
            handles={false}
            onUpdate={(event, dataSource) =>
                handleOrderChange(event, dataSource)
            }

            row={(a, index) => {
                return <Card onClick={() => selectPreset(a.interactionPresetId)} className="dark-card" style={{ padding: '0px', margin: '5px 0px', border: a.active ? "3px solid #20a8d8e0" : '3px solid transparent' }}>
                    <ListItem>
                        <IconButton className="icon-button-dark-s" style={{ cursor: 'move', color: '#ffffff99' }}>
                            <DragIndicatorIcon />
                        </IconButton>
                        <Input style={{ color: '#FFFFFF99', backgroundColor: '#3a3b3c', border: '0px', padding: '5px 10px', width: '100%', display: 'inline-block' }}
                            value={a.name} onChange={(e) => onEdit(e.target.value, index)} />
                        <IconButton className="icon-button-dark-s" onClick={() => toggleDelete(true, a.interactionPresetId)} style={{ cursor: 'pointer', color: '#ffffff99' }}>
                            <DeleteIcon />
                        </IconButton>
                    </ListItem>
                </Card>
            }} />

    </div>

}



